import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-adpm-services',
  template: `
    <p>
      adpm-services works!
    </p>
  `,
  styles: []
})
export class AdpmServicesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
